import {
	aagazLogo,
	mridangLogo,
	noScopeLogo,
	safarnamaLogo,
	yaariyanLogo,
} from "./images";

const events = [
	{
		id: "dckjwbkjebf32iub3of2b",
		title: "Mridang",
		image: mridangLogo,
		about: `Mridang is the cultural fest of Indian Institute of Information Technology Una, Organized by the Event Planning Management and Organization Council. It is a fest in which a lot of talent get a platform to explore. Singing, Dancing, stand up comedy, skits, Rock Bands these are the various performances which is performed in Mridang. Mridang is all set to go to new height in the upcoming years. Rock on! `,
		color: "brown",
	},
	{
		id: "skvjnqiwfh2893h",
		title: "No Scope",
		image: noScopeLogo,
		about: `ed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequun`,
		color: "red",
	},
	{
		id: "9283hf928h3f2f",
		title: "Safarnama",
		image: safarnamaLogo,
		about: `r magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel `,
		color: "green",
	},
	{
		id: "kebnvkwebdnvkwabenvl",
		title: "Aagaz",
		image: aagazLogo,
		about: `r magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel `,
		color: "brown",
	},
	{
		id: "f9832ghf928",
		title: "Yaariyan",
		image: yaariyanLogo,
		about: `r magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel `,
		color: "orange",
	},
];
export default events;
